// Type Imports
import type { AccessControlProvider } from '@refinedev/core'

// API Imports
import { apiFetch } from '@/lib/api/client'

import type { SessionUser } from '@/types/api'

/*
 * The permission set is fetched once and cached for the life of the tab. It is a
 * UI-shaping cache only: hiding a button the user cannot use. Every call it would
 * have made is still checked by the API's PermissionsGuard, so a stale cache can
 * show an extra button, never grant an extra action.
 */
let cached: Promise<Set<string>> | null = null

const loadPermissions = (): Promise<Set<string>> => {
  cached ??= apiFetch<SessionUser>('/auth/me')
    .then(me => new Set(me.permissions))
    .catch(() => {
      cached = null

      return new Set<string>()
    })

  return cached
}

/** Call after anything that can change the signed-in user's own grants. */
export const invalidatePermissions = (): void => {
  cached = null
}

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, action }) => {
    if (!resource) return { can: true }

    const permissions = await loadPermissions()

    // Refine asks `can({ action: 'edit' })` for both the button and the route;
    // the API's permission keys are `<resource>:<action>` with the same verbs.
    if (permissions.has(`${resource}:${action}`)) {
      return { can: true }
    }

    return { can: false, reason: 'Танд энэ үйлдлийг хийх эрх байхгүй байна' }
  },
  options: {
    buttons: { enableAccessControl: true, hideIfUnauthorized: true }
  }
}
